
const from = key => {
    const str = localStorage.getItem(key)
    if (str === null) {
        return null
    }

    try {
        JSON.parse(str)
    } catch (e) {
        return str
    }
}

const to = (key, value) => localStorage.setItem(key, value)

const call =  {
    xAuthToken: {
        set (token) {
            to('x-auth-token', token)
        },
        get () {
            return from('x-auth-token')
        }
    },
    clearAll () {
        localStorage.clear()
    }
}

export default call

